import { useHistory } from "react-router-dom"
import { useTableErrorConfig } from "../../../../../../../_webui/layout/components/Table/Error/modules/useTableErrorConfig"
import { useApi } from "../useApi"
import { useTableConfig } from "../useTableConfig"
import { useVariablesModal } from "../useVariablesModal"
import { useVariablesAuthority } from "../useVariablesAuthority"

export const useVariables = () => {
  const { push } = useHistory()
  const { columnErrors } = useTableErrorConfig()
  const { columns } = useTableConfig()

  const {
    isNotAccessScreen,
    isRoleSubAdmin,
    isVisibleBtnCancel,
    isVisibleBtnRegister,
  } = useVariablesAuthority()

  const {
    isOpen,
    isOpenUploaded,
    onCancel,
    onCancelUploaded,
    onOpen,
    onOpenDeleted,
  } = useVariablesModal()

  const {
    beforeUpload,
    bulkAdd,
    bulkCheck,
    bulkDeleteData,
    bulkFileAdd,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    form,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isResetTable,
    onChange,
    perItem,
  } = useApi({
    onCancel,
    onCancelUploaded,
  })

  return {
    beforeUpload,
    bulkAdd,
    bulkCheck,
    bulkDeleteData,
    bulkFileAdd,
    columnErrors,
    columns,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    form,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isNotAccessScreen,
    isOpen,
    isOpenUploaded,
    isResetTable,
    isRoleSubAdmin,
    isVisibleBtnCancel,
    isVisibleBtnRegister,
    onCancel,
    onCancelUploaded,
    onChange,
    onOpen,
    onOpenDeleted,
    perItem,
    push,
  }
}
